import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from '@mui/x-data-grid-pro';
import { Table, TableDetailToggle } from '../../components/table/Table';
import { selectors } from '../../store/dux/yield-dux';
import { getRounded } from '../../lib/numbers';
import YieldEditCrop from './YieldEditCrop';

export default function GrowerYieldRawTab() {
  const rawYield = useSelector(selectors.rawYield);

  const getDetailPanelContent = useCallback(
    ({ row }) => (
      <Box
        sx={{
          paddingLeft: '62%',
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        }}
      >
        {row?.crops?.map(({ crop, coverage }) => (
          <YieldEditCrop
            crop={crop}
            coverage={coverage}
            aaid={row.aaid}
            status={row.status}
            fieldName={row.fieldName}
            key={crop}
          />
        ))}
      </Box>
    ),
    [],
  );

  const getDetailPanelHeight = useCallback(() => 'auto', []);

  const columns = [
    {
      field: 'harvestedCrop',
      headerName: 'Harvested Crop',
      flex: 1,
      renderCell: ({ row }) =>
        row.crops && row.crops.length > 1
          ? `Multiple (${row.crops.length})`
          : row.harvestedCrop,
    },
    {
      ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
      type: 'string',
      renderHeader: () => <div className="MuiDataGrid-columnHeaderTitle" />,
      renderCell: (params) =>
        params.row?.crops?.length > 1 ? (
          <TableDetailToggle id={params.id} value={params.value} />
        ) : undefined,
      valueGetter: () => '',
    },
    {
      field: 'rawStatus',
      headerName: 'Status',
      flex: 1,
    },
    {
      field: 'coverage',
      headerName: 'Coverage',
      valueGetter: (params) => getRounded(params.value, 0),
      flex: 1,
    },
  ];

  return (
    <Table
      loading={!rawYield}
      fields={rawYield || []}
      columns={columns}
      getDetailPanelContent={getDetailPanelContent}
      getDetailPanelHeight={getDetailPanelHeight}
      isRowSelectable={() => true}
      initialState={{
        sorting: {
          sortModel: [{ field: 'fieldName', sort: 'asc' }],
        },
      }}
    />
  );
}
